// ── 1) モーダル開閉ロジック ──────────────
(function () {
  const modal = document.getElementById('halalModal');
  const overlay = modal.querySelector('.halal-modal__overlay');
  const closeBtn = modal.querySelector('.halal-modal__close');

  function openHalalModal() {
    modal.classList.add('is-active');
  }
  function closeHalalModal() {
    modal.classList.remove('is-active');
  }
  // 背景とクローズボタンで閉じる
  [overlay, closeBtn].forEach((el) => el.addEventListener('click', closeHalalModal));

  window.openHalalModal = openHalalModal;
  window.closeHalalModal = closeHalalModal;
})();

// ── 2) Checkout ボタンクリック監視 & モーダル起動 ────────
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.js-halal-certificate-btn');

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      // 定義済みのモーダル表示関数を呼び出し
      if (typeof openHalalModal === 'function') {
        openHalalModal();
      } else {
      }
    });
  });
});
